export enum AmendOrderType {
  CANCEL,
  RETURN,
}
